import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl/dist';


const SSN = props => {
    const {
        inputData: {
            id,
            isInputRequired,
            inputClasses,
            name,
            type
        },
        label: {
            labelText,
            labelClasses
        },
        legend: {
            isLegendRequired,
            helperClasses
        },
        actions: {
            handleFieldChange
        }
    } = props;

    //const  [ accessCode, setAccessCode ] = useState(accessCode);
    const  [ssn, setSsn] = useState('');
    const  [ssnUndo, setUndoSsn] = useState('');
    const _onInputChange = event => {
        // var re = /^[0-9\b]+$/;
        //
        var string = event.target.value;

        string = string.replace(/-/g, '');
        var regex = /^([0-9]{3})([0-9]{2})([0-9]{4})$/g;
        var match = regex.exec(string);
        if (match) {
            match.shift();
            string = match.join('-');
        }

        string = string.replace(/[^\d-]/g, '');
        handleFieldChange({ target: { name:'ssn',value:string } });
        setSsn( string );
        setUndoSsn(string);
    };

    const _mask = () => {
        var r = new RegExp('(?:d{3})-(?:d{2})-(d{4})');
        var str = ssn;
        var result = str.replace(r, '###-##-');

        var res = result.slice(6);
        let maskedSsn = '***-**' + res;

        if(ssn === ''){
            setSsn('');
        }
        else {
            setSsn(maskedSsn);
        }
    };
    const _reveal = () => {
        setSsn(ssnUndo);
    };

    return (
        <Fragment>

            <div className={`grid-row gi-ssn ${helperClasses && helperClasses.join(' ')}`}>
                <label
                    htmlFor={id}
                    className={`gi-ssn__label ${labelClasses && labelClasses.join(' ')}`}
                    aria-label={isInputRequired}
                >
                    <span className={`required-${isLegendRequired}`}>
                        <FormattedMessage id={labelText} />
                    </span>
                </label>
                <input
                    id={id}
                    name={name}
                    type={type}
                    value={ssn}
                    className={`gi-ssn__input ${inputClasses && inputClasses.join(' ')}`}
                    aria-required={isInputRequired}
                    onChange={_onInputChange}
                    maxLength="9"
                    onBlur={_mask}
                    onFocus={_reveal}
                />
            </div>
        </Fragment>
    );
};

export default SSN;

